import axios from 'axios'
import { get } from 'lodash'
import { Notification } from 'element-ui'
const request = axios.create()

request.interceptors.response.use(
  (response) => {
    let status = get(response, 'data.status')
    if (status === 200) {
      return response.data
    } else {
      let message = get(response, 'data.message')
      if (!Array.isArray(message) || message.length < 1) {
        message = ['未知错误']
      }
      Notification.error({
        title: `错误`,
        dangerouslyUseHTMLString: true,
        message: `${message.join('<br/>')}`
      })
      return Promise.reject(new Error(status + ': ' + response.data.msg))
    }
  },
  (error) => {
    Notification.error({
      title: `${error.response.status} 错误`,
      dangerouslyUseHTMLString: true,
      message: get(error, 'response.data.message', '未知错误')
    })
    return Promise.reject(error)
  }
)

export default request
